<template>
  <div>
    <md-dialog
      :md-active.sync="showDialog"
      style="overflow: visible"
      @md-clicked-outside="closeDialog"
    >
      <div class="custom-header">
        <md-dialog-title>Оплатить онлайн</md-dialog-title>
        <md-button
          class="md-button md-just-icon md-simple"
          @click="closeDialog"
        >
          <i class="material-icons ">close</i>
        </md-button>
      </div>

      <md-list class="md-double-line md-dense">
        <md-list-item
          v-for="(payment, i) in paymentsList"
          :key="i"
          :href="payment.value"
          target="_blank"
        >
          <div class="md-list-item-text">
            <span>{{ payment.name }}</span>
            <span>{{ payment.comment }}</span>
          </div>
          <md-icon class="md-primary">chevron_right</md-icon>
        </md-list-item>
        <md-divider></md-divider>
      </md-list>
      <div class="custom-content">
        <span class="md-caption">{{ paymentsNote }}</span>
        <div>
          <img class="img" :src="iconsUrl.visa" alt="visa" />
          <img class="img" :src="iconsUrl.ms" alt="master card" />
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DialogPaymentVariants",
  data() {
    return {
      iconsUrl: {
        visa: "./img/icons/visa.svg",
        ms: "./img/icons/mastercard.svg"
      },
      show: false
    };
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.show = this.showDialog;
  },
  computed: {
    ...mapGetters(["getManageOrganizationInfo"]),

    paymentsList() {
      if (this.getManageOrganizationInfo.hasOwnProperty("services")) {
        return this.getManageOrganizationInfo.services.payments.paymentsList;
      }
      return [];
    },

    paymentsNote() {
      if (this.getManageOrganizationInfo.hasOwnProperty("services")) {
        return this.getManageOrganizationInfo.services.payments.paymentsNote;
      }
      return "";
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="scss" scoped>
.md-list {
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  .md-list-item a {
    text-transform: initial;
  }
  .md-list-item-text * {
    text-overflow: initial;
    white-space: normal;
  }
}

.custom-content {
  .img {
    width: 50px;
    margin: 0 5px;
  }
}
</style>
